import React from 'react'
import Restaurant from './components/Restaurant'


const App = () => {
  return <Restaurant />
}

export default App